import { useCallback } from "react"
import { track } from "tracking/client"

export type TrackExperimentViewed = (
  experimentId: string,
  experimentVariant: number,
  experimentVariantName?: string
) => void

export type UseExperimentViewed = TrackExperimentViewed

export function trackExperimentViewed(
  experimentId: string,
  experimentVariant: number,
  experimentVariantName?: string
): void {
  const key = `ExperimentViewed__${experimentId}__${experimentVariant}`

  if (sessionStorage?.getItem(key)) return

  track({
    event: "Experiment Viewed",
    properties: {
      experiment_id: experimentId,
      experiment_variant: experimentVariant,
      ...(experimentVariantName && {
        experiment_variant_name: experimentVariantName,
      }),
    },
  })

  sessionStorage.setItem(key, "1")
}

export const useExperimentViewed = (): UseExperimentViewed => {
  const trackExperimentViewedCallback: TrackExperimentViewed = useCallback(
    trackExperimentViewed,
    []
  )

  return trackExperimentViewedCallback
}
